export class EnumConfigModel {
  DocAction: Array<any> = new Array<any>();
  DocStatus: Array<any> = new Array<any>();
  Gender: Array<any> = new Array<any>();
  LoanFlag: Array<any> = new Array<any>();
  LoanTag: Array<any> = new Array<any>();
  LoanType: Array<any> = new Array<any>();
  MaritalStatus: Array<any> = new Array<any>();
  RoleAccess: Array<any> = new Array<any>();
  RoleTypeEnum: Array<any> = new Array<any>();
  ClientSubSector: Array<any> = new Array<any>();
  BusinessSector: Array<any> = new Array<any>();
}
